var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasPermission(_vm.permission))?_c('tooltip',{attrs:{"label":"Cancel","type":"small","placement":"top"}},[_c('button',{staticClass:"button is-danger",attrs:{"type":"button"},on:{"click":_vm.onClick}},[_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa fa-ban"})])])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }